export default "__VITE_ASSET__BqY87DnD__"